"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _iconLibrary = require("../icon/icon-library");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Chip.css");

var _styles = {
  "chip": "Chip__chip___1WCT5",
  "with_icon": "Chip__with_icon___yKhvl",
  "icon-container": "Chip__icon-container___2Sm7f",
  "text": "Chip__text___13OWa",
  "truncate": "Chip__truncate___WC0T4",
  "soft_success": "Chip__soft_success___bnnE3",
  "hard_success": "Chip__hard_success___OOr4C",
  "money_available": "Chip__money_available___-_Neq",
  "pending": "Chip__pending___1K1tG",
  "soft_failure": "Chip__soft_failure___4r7IP",
  "hard_failure": "Chip__hard_failure___3uyO8",
  "info": "Chip__info___2Gm9K",
  "warning": "Chip__warning___1Ksc8"
};

const styles = _bind.default.bind(_styles);

const ICON_MAPPING = {
  soft_success: {
    icon: _iconLibrary.IconEnum.check_circle_filled,
    color: _.Color.neutral._90
  },
  hard_success: {
    icon: _iconLibrary.IconEnum.check_circle_filled,
    color: _.Color.semantic.$success50
  },
  money_available: {
    icon: _iconLibrary.IconEnum.circle_dollar,
    color: _.Color.semantic.$success50
  },
  pending: {
    icon: _iconLibrary.IconEnum.circle_half_stroke,
    color: _.Color.neutral._90
  },
  soft_failure: {
    icon: _iconLibrary.IconEnum.circle_xmark_filled,
    color: _.Color.neutral._60
  },
  hard_failure: {
    icon: _iconLibrary.IconEnum.exclamation_triangle,
    color: _.Color.semantic.$error50
  },
  info: {
    icon: _iconLibrary.IconEnum.info_circle,
    color: _.Color.neutral._60
  },
  warning: {
    icon: _iconLibrary.IconEnum.exclamation_triangle,
    color: _.Color.semantic.$warning50
  }
};
const Chip = (0, _mobxReact.observer)(({
  dataTestId,
  className,
  variant,
  text,
  textSize,
  textVariant = 'medium',
  textColor,
  truncate,
  showIcon = true,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('chip', variant, showIcon ? 'with_icon' : undefined), className);
  return _react.default.createElement(_.Flex, {
    dataTestId: dataTestId,
    gap: 4,
    className: composed_classname,
    inline: true,
    alignItems: 'center',
    ...props
  }, showIcon && _react.default.createElement("div", {
    className: styles('icon-container')
  }, _react.default.createElement(_.Icon, {
    dataTestId: dataTestId && `${dataTestId}-icon`,
    name: variant ? ICON_MAPPING[variant].icon : _iconLibrary.IconEnum.circle_dashed,
    color: variant ? ICON_MAPPING[variant].color : _.Color.neutral._90,
    size: 18,
    viewBoxSize: 24
  })), _react.default.createElement(_.Text, {
    dataTestId: dataTestId && `${dataTestId}-text`,
    className: styles('text', {
      truncate
    }),
    color: textColor,
    size: textSize,
    variant: textVariant,
    text: text
  }));
});
var _default = Chip;
exports.default = _default;